import React from "react";

import { languages } from "@examspark/common/dist/meta/language";

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  excludeEmpty?: boolean;
}

export const LanguageSelect: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  const { excludeEmpty, ...selectProps } = props;

  return (
    <select {...selectProps}>
      {!excludeEmpty && <option value="">Select Language...</option>}
      <optgroup label="Commonly Used">
        <option value="EN">English</option>
        <option value="ES">Spanish</option>
        <option value="DE">German</option>
        <option value="FR">French</option>
        <option value="VI">Vietnamese</option>
      </optgroup>
      <optgroup label="All Languages">
        {languages.map((value) => (
          <option key={value[1].toUpperCase()} value={value[1].toUpperCase()}>
            {value[0]}
          </option>
        ))}
      </optgroup>
    </select>
  );
};
